import React, { useState } from 'react';
import fetchAPI from '../../../common/fetchAPI';
import { ShowToast } from '../../../common/Toastr';
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
    updateSelectedResource, updateUnSelectedResource, updateAllSelectedAndUnSelected, selectedAndUnSelectedOnEditMode,
    updateSelectedRemainderTeam, updateUnSelectedRemainderTeam, updateSelectUnSelectRemainderTeam, selectUnSelectRemainderTeamOnEditMode,
    searchProjectTaskTeam, searchTaskRemainderTeam
} from "../TasksSlice";
import { t } from 'i18next';
import { getValueFromResource } from '../../../common/timeLiveFunction';
const TeamResource = (props: any) => {
    const dispatch = useAppDispatch();
    const [selectAll, setSelectAll] = useState<boolean>(false);
    const [searchTeam, setSearchTeam] = useState('');
    const [searchRemainderTeam, setSearchRemainderTeam] = useState('');
    const { taskTeamList, remainderTeamList, accountProjectTaskId } = useAppSelector((state) => state.tasks);
    const { name } = props;
    
    const getEmployeeRate = async (data: any, employeeId: any) => {
        const response = await fetchAPI(`api/BillingRates/GetByEmployee/${employeeId}`, 'Get', '', true);
        const json = await response.json();
        if (!json[0].Message) {
            //dispatch(updateEmployeeCost({ 'hours': Number(data), 'employeeRate': Number(json[0].EmployeeRate), 'accountEmployeeId': employeeId }));
        } else {
            ShowToast('error', json[0].Message, "error", "toast-top-right");
        }
    }

    const selectUnSelect = (isSelect: boolean) => {     
        if (accountProjectTaskId != 0) {
            dispatch(selectedAndUnSelectedOnEditMode(isSelect));
        } else {
            const newState = taskTeamList.map((obj: any) => {
                return { ...obj, IncludeTeam: isSelect ? 1 : 0 };
            });
            dispatch(updateAllSelectedAndUnSelected(newState));
        }
    }

    const selectUnSelectForRemainderTeam = (isSelect: boolean) => {      
        if (accountProjectTaskId != 0) {
            dispatch(selectUnSelectRemainderTeamOnEditMode(isSelect));
        } else {
            const newState = remainderTeamList.map((obj: any) => {
                return { ...obj, IncludeTeam: isSelect ? 1 : 0 };
            });
            dispatch(updateSelectUnSelectRemainderTeam(newState));
        }
    }

    const onSwitchCheckAll = (data: any) => {
        selectAll ? setSelectAll(false) : setSelectAll(true);
        name == "TaskTeam" ? data.target.checked ? selectUnSelect(true) : selectUnSelect(false) :
            data.target.checked ? selectUnSelectForRemainderTeam(true) : selectUnSelectForRemainderTeam(false);
    }
    
    // const onHandleSearch = (event: any) => {
    //     console.log('HandlTaskTeam', event.target)
    //     const { value } = event.target;
    //      name === 'TaskTeam' ? setSearchTeam(value) : setSearchRemainderTeam(value);
    //      name === 'TaskTeam' ? dispatch(searchProjectTaskTeam(value)) : dispatch(searchTaskRemainderTeam(value));
    // }

    const onHandleSearch = (event: any) => {
        const { value } = event.target;
         name === 'TaskTeam' ? setSearchTeam(value) : setSearchRemainderTeam(value);
         name === 'TaskTeam' ? dispatch(searchProjectTaskTeam(value)) : dispatch(searchTaskRemainderTeam(value));
    };

    return (
        <>
            <div className='row selectAllDiv'>
                <div className="col-md-6">
                    <div className="wrapper" style={{ marginLeft: -10 }}>
                        <input
                            type="text"
                            value={name === 'TaskTeam' ? searchTeam : searchRemainderTeam}
                            onChange={onHandleSearch}
                            placeholder=
                            // {t('Search')}
                            {getValueFromResource('Search',dispatch, t)}
                            className="form-control h-35px w-225px fs-7 fw-normal mb-2"
                        />
                        <i className="insideField-Search-Icons ki-outline ki-magnifier text-gray"></i>
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-check form-switch form-check-custom form-check-solid me-0" style={{ justifyContent: 'flex-end', marginBottom: 10 }}>
                        <input
                            className="form-check-input h-20px w-30px me-2"
                            type='checkbox'
                            name='CheckAll'
                            checked={selectAll}
                            onChange={(e) => { onSwitchCheckAll(e) }}
                        />
                        <span className='form-label fs-7 fw-normal mt-2'>
                            {/* {t('Select All')} */}
                            {getValueFromResource('Select All',dispatch, t)}
                            </span>
                    </div>
                </div>
            </div>
            <div className="table-responsive">
                <table className="table table-row-bordered table-bottom-color align-middle gs-2 gy-3 gx-0">
                    <thead>
                        <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                            <th style={{ width: 72 }}></th>
                            <th>
                                {/* {t("Employee Name")} */}
                                {getValueFromResource('Employee Name',dispatch, t)}
                                </th>
                        </tr>
                    </thead>
                    <tbody>
                        {name == "TaskTeam" && taskTeamList?.length > 0 && taskTeamList.map((item: any, index: any) => {
                            return (
                                <tr key={item.Id}>
                                    <td>
                                        {item.IncludeTeam == 0 ?
                                            <div className='symbol symbol-circle symbol-35px cursor'
                                                onClick={() => dispatch(updateSelectedResource(item.Id))}
                                            >
                                                <div className='symbol-label fw-bold'
                                                    style={{ backgroundColor: item.ProfilePictureColor != '' ? item.ProfilePictureColor : '#512da8', color: '#fff', marginRight: 8 }}>
                                                    {`${item.FirstName.charAt(0).toUpperCase()}${item.LastName.charAt(0).toUpperCase()}`}
                                                </div>
                                            </div> :
                                            <div className='symbol symbol-circle symbol-35px cursor'
                                                onClick={() => dispatch(updateUnSelectedResource(item.Id))}
                                            >
                                                <div className="symbol symbol-35px me-2">
                                                    <span className="symbol-label bg-light-primary">
                                                        <i className="ki-outline ki-check-circle text-primary fs-1"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    </td>
                                    <td>
                                        <span className='cursor' onClick={() => {
                                            item.IncludeTeam == 0 ?
                                                dispatch(updateSelectedResource(item.Id)) :
                                                dispatch(updateUnSelectedResource(item.Id))
                                        }}>{item.Name}</span>
                                    </td>
                                </tr>)
                        })}
                        {name == "RemainderTaskTeam" && remainderTeamList && remainderTeamList.map((item: any, index: any) => {
                            return (
                                <tr key={item.Id}>
                                    <td>
                                        {item.IncludeTeam == 0 ?
                                            <div className='symbol symbol-circle symbol-35px cursor'
                                                onClick={() => dispatch(updateSelectedRemainderTeam(item.Id))}
                                            >
                                                <div className='symbol-label fw-bold' style={{ backgroundColor: item.ProfilePictureColor != '' ? item.ProfilePictureColor : '#512da8', color: '#fff', marginRight: 8 }}>
                                                    {`${item.FirstName.charAt(0).toUpperCase()}${item.LastName.charAt(0).toUpperCase()}`}
                                                </div>
                                            </div> :
                                            <div className='symbol symbol-circle symbol-35px cursor'
                                                onClick={() => dispatch(updateUnSelectedRemainderTeam(item.Id))}
                                            >
                                                <div className="symbol symbol-35px me-2">
                                                    <span className="symbol-label bg-light-primary">
                                                        <i className="ki-outline ki-check-circle text-primary fs-1"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    </td>
                                    <td>
                                        <span className='cursor' onClick={() => {
                                            item.IncludeTeam == 0 ?
                                                dispatch(updateSelectedRemainderTeam(item.Id)) :
                                                dispatch(updateUnSelectedRemainderTeam(item.Id))
                                        }}>{item.Name}</span>
                                    </td>
                                </tr>)
                        })}
                    </tbody>
                </table>
                {name == "TaskTeam" && taskTeamList.length === 0 &&
                    <div className=''>
                        <p className='noDataFound'>
                            {/* {t('No Record Found')} */}
                            {getValueFromResource('No Record Found',dispatch, t)}
                            </p>
                    </div>
                }
                {name == "RemainderTaskTeam" && remainderTeamList.length === 0 &&
                    <div className=''>
                        <p className='noDataFound'>
                            {/* {t('No Record Found')} */}
                            {getValueFromResource('No Record Found',dispatch, t)}
                            </p>
                    </div>
                }
            </div>
        </>
    )
}

export default TeamResource